import { render, staticRenderFns } from "./Scancodeapply.vue?vue&type=template&id=50b4d93b&scoped=true&"
import script from "./Scancodeapply.vue?vue&type=script&lang=js&"
export * from "./Scancodeapply.vue?vue&type=script&lang=js&"
import style0 from "./Scancodeapply.vue?vue&type=style&index=0&id=50b4d93b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4d93b",
  null
  
)

export default component.exports